import { render, staticRenderFns } from "./AvatarOne.vue?vue&type=template&id=72caea48&"
import script from "./AvatarOne.vue?vue&type=script&lang=ts&"
export * from "./AvatarOne.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports